module.exports = {
	"_args": [
		[
			"axios@^0.14.0",
			"/Users/jeffkang/Documents/Project/OpenSource/instaparser"
		]
	],
	"_from": "axios@>=0.14.0 <0.15.0",
	"_id": "axios@0.14.0",
	"_inCache": true,
	"_installable": true,
	"_location": "/axios",
	"_nodeVersion": "6.2.2",
	"_npmOperationalInternal": {
		"host": "packages-16-east.internal.npmjs.com",
		"tmp": "tmp/axios-0.14.0.tgz_1472322619923_0.0996575120370835"
	},
	"_npmUser": {
		"email": "nick.uraltsev@gmail.com",
		"name": "nickuraltsev"
	},
	"_npmVersion": "3.9.5",
	"_phantomChildren": {},
	"_requested": {
		"name": "axios",
		"raw": "axios@^0.14.0",
		"rawSpec": "^0.14.0",
		"scope": null,
		"spec": ">=0.14.0 <0.15.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/axios/-/axios-0.14.0.tgz",
	"_shasum": "40f24f2f4e913b9faa43d3a7b2e40ab8729afa90",
	"_shrinkwrap": null,
	"_spec": "axios@^0.14.0",
	"_where": "/Users/jeffkang/Documents/Project/OpenSource/instaparser",
	"author": {
		"name": "Matt Zabriskie"
	},
	"browser": {
		"./lib/adapters/http.js": "./lib/adapters/xhr.js"
	},
	"bugs": {
		"url": "https://github.com/mzabriskie/axios/issues"
	},
	"dependencies": {
		"follow-redirects": "0.0.7"
	},
	"description": "Promise based HTTP client for the browser and node.js",
	"devDependencies": {
		"coveralls": "^2.11.9",
		"es6-promise": "^3.2.1",
		"grunt": "0.4.5",
		"grunt-banner": "0.6.0",
		"grunt-cli": "0.1.13",
		"grunt-contrib-clean": "1.0.0",
		"grunt-contrib-nodeunit": "1.0.0",
		"grunt-contrib-watch": "0.6.1",
		"grunt-eslint": "18.0.0",
		"grunt-karma": "0.12.1",
		"grunt-ts": "5.3.2",
		"grunt-typings": "0.1.5",
		"grunt-webpack": "1.0.11",
		"istanbul-instrumenter-loader": "^0.2.0",
		"jasmine-core": "^2.4.1",
		"karma": "^0.13.22",
		"karma-chrome-launcher": "^1.0.1",
		"karma-coverage": "^1.0.0",
		"karma-firefox-launcher": "^1.0.0",
		"karma-jasmine": "^1.0.2",
		"karma-jasmine-ajax": "^0.1.13",
		"karma-opera-launcher": "^1.0.0",
		"karma-phantomjs-launcher": "^1.0.0",
		"karma-safari-launcher": "^1.0.0",
		"karma-sauce-launcher": "^1.0.0",
		"karma-sinon": "^1.0.5",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-webpack": "^1.7.0",
		"load-grunt-tasks": "3.4.1",
		"minimist": "^1.2.0",
		"phantomjs-prebuilt": "^2.1.7",
		"sinon": "^1.17.4",
		"url-search-params": "^0.5.0",
		"webpack": "^1.13.1",
		"webpack-dev-server": "^1.14.1"
	},
	"directories": {},
	"dist": {
		"shasum": "40f24f2f4e913b9faa43d3a7b2e40ab8729afa90",
		"tarball": "https://registry.npmjs.org/axios/-/axios-0.14.0.tgz"
	},
	"gitHead": "c96348660dacddd32676924d4f1bde535c45fb77",
	"homepage": "https://github.com/mzabriskie/axios",
	"keywords": [
		"xhr",
		"http",
		"ajax",
		"promise",
		"node"
	],
	"license": "MIT",
	"main": "index.js",
	"maintainers": [
		{
			"email": "mzabriskie@gmail.com",
			"name": "mzabriskie"
		},
		{
			"email": "nick.uraltsev@gmail.com",
			"name": "nickuraltsev"
		}
	],
	"name": "axios",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/mzabriskie/axios.git"
	},
	"scripts": {
		"build": "NODE_ENV=production grunt build",
		"coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
		"examples": "node ./examples/server.js",
		"postversion": "git push && git push --tags",
		"preversion": "npm test",
		"start": "node ./sandbox/server.js",
		"test": "grunt test",
		"version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
	},
	"typings": "./axios.d.ts",
	"version": "0.14.0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/package.json
 ** module id = 328
 ** module chunks = 0
 **/